export default "__VITE_ASSET__504a7fcd__"